import Title from "./components/Title/Title";
import Paragraph from "./components/Paragraph/Paragraph";
import Button from "./components/Button/Button";
import OptionsItem from "./components/OptionsItem/OptionsItem";
import React, { useEffect, useState } from "react";
import imageStartScreen from "./assets/images/00.jpg";
import imageResultNSpicy from "./assets/images/N99.jpg";
import imageResultMSpicy from "./assets/images/M99.jpg";
import imageResultTSpicy from "./assets/images/T99.jpg";
import styles from "./App.module.scss";
import questions from "./state/questions";
import classNames from "classnames";
import Result from "./components/Result/Result";

function App() {
  const [currentQuestion, setCurrentQuestion] = useState(0); // считаем номер вопроса
  const [stateFlow, setStateFlow] = useState("Start"); // состояние флоу: стартовый экран / вопросы / результат
  const [option, setOption] = useState(false); // выбран ли ответ
  const [resultState, setResultState] = useState(""); // выводить ли результат
  const [resultCount, setResultCount] = useState(0); // счетчик правильных вопросов
  const phone = document.getElementById("phone"); // находим область телефона на десктопе

  // console.log(resultCount); // тестирование логики

  // прокрутка вниз при нажатии на ответ
  const optionActiveHandler = (option) => {
    setOption(option);

    setTimeout(() => {
      window.scrollTo({ top: 1000, behavior: "smooth" });
      phone.scrollTo({ top: 1000, behavior: "smooth" });
    }, "50");
  };

  const resultCountLogic = (result) => {
    setResultCount(resultCount + result);
  };

  // поднимаемся наверх после перехода на страницу
  const scrollReset = (event) => {
    window.scrollTo(0, 0);
    phone.scrollTo(0, 0);
  };

  // Скролл наверх при нажатии старт квиз
  const startFlow = () => {
    setStateFlow("Flow");
    window.scrollTo(0, 0);
  };

  // логика флоу
  const handlerNext = () => {
    if (currentQuestion === 4) {
      setStateFlow("End");

      setResultState(() => {
        if (resultCount >= 0 && resultCount <= 1) {
          return (
            <Result
              score={resultCount + " แซ่บแบบเบา ๆ 🥥"}
              title="ในขณะที่คนอื่นกำลังถกกันเรื่องประวัติศาสตร์อาหาร คุณกลับเลือกมีความสุขกับสิ่งที่อยู่ตรงหน้า เรานับถือจากใจเลย เรียบง่าย ไม่ต้องคิดเยอะ"
              text={
                "ถ้าเริ่มหิวเมื่อไหร่ ให้ Maxim ดูแลนะ ไม่ว่าจะเป็นต้มข่าไก่ คั่วกลิ้ง หรือเมนูไหนที่คุณชอบ เราพร้อมส่งให้ถึงมือ ใช้โค้ดส่วนลด SPICY สำหรับการสั่งซื้อครั้งแรกของคุณ 👇"
              }
              imageSrc={imageResultNSpicy}
              posterContainer={styles.posterContainer}
              optionsContainer={styles.optionsContainer}
              handlerBack={handlerBack}
            />
          );
        }

        if (resultCount >= 2 && resultCount <= 3) {
          return (
            <Result
              score={resultCount + " แซ่บปานกลาง 🌶️"}
              title="เก่งเลยล่ะ ไม่ใช่มือใหม่แล้ว รู้เรื่องอาหารพอสมควร และยังกล้าลองอะไรใหม่ ๆ รสนิยมดี เซนส์ใช้ได้เลย"
              text={
                "หิวเมื่อไหร่ก็สั่งกับ Maxim ได้เลย ใช้โค้ด SPICY แล้วไปอร่อยกัน 👇"
              }
              imageSrc={imageResultMSpicy}
              posterContainer={styles.posterContainer}
              optionsContainer={styles.optionsContainer}
              handlerBack={handlerBack}
            />
          );
        }

        if (resultCount >= 4 && resultCount <= 5) {
          return (
            <Result
              score={resultCount + " สายแซ่บแบบไทย ๆ 🔥"}
              title="โอ้โห…เอาเรื่องอยู่นะ ไม่ใช่แค่รู้เยอะ แต่คือรู้จริงแบบตัวแม่ตัวพ่อสายกินเลย 🔥 ระดับนี้ไม่เรียกแฟนอาหารธรรมดาแล้ว เรียก “ตัวตึงวงการของกิน” 👏"
              text={
                "ทั้งขนมโปรตุเกส การหมักแบบเกาหลี คุณรู้หมดเลยนะ เอาเป็นว่า… Maxim พร้อมแล้ว หิวเมื่อไหร่ก็สั่งได้เลย ใช้โค้ด SPICY แล้วรับส่วนลดไปเลย 👇"
              }
              imageSrc={imageResultTSpicy}
              posterContainer={styles.posterContainer}
              optionsContainer={styles.optionsContainer}
              handlerBack={handlerBack}
            />
          );
        }
      });

      // сбрасываем  скролл для результата
      scrollReset();
    } else {
      setOption(false);
      setCurrentQuestion(currentQuestion + 1);

      // прокрутка вверх после нажатия на ответ
      setTimeout(() => {
        window.scrollTo({ top: 0, behavior: "smooth" });
        phone.scrollTo({ top: 0, behavior: "smooth" });
      }, "50");
    }
  };

  // возвращение в начало
  const handlerBack = () => {
    setOption(false);
    setStateFlow("Start");
    setCurrentQuestion(0);
    setResultCount(0);
  };

  // считаем цифры прокрутки и верешаем options::after
  const [offset, setOffset] = useState(false);

  useEffect(() => {
    const handleScroll = (event) => {
      if (window.scrollY > 50) {
        setOffset(true);
      } else {
        setOffset(false);
      }
    };

    window.addEventListener("scroll", handleScroll);

    return () => {
      window.removeEventListener("scroll", handleScroll);
    };
  }, []);

  return (
    <div className={styles.wrapperContainer}>
      <div className={styles.wrapper}>
        <div className={styles.phone} id="phone">
          {stateFlow === "Start" ? (
            <>
              <div className={styles.posterContainer}>
                <img src={imageStartScreen} className={styles.image} alt="" />
              </div>
              <div
                className={classNames({
                  [styles.optionsContainer]: true,
                  [styles.onScrollOption]: offset,
                })}
              >
                <div className={styles.bgWhite}>
                  <div className={styles.contentWrapper}>
                    <Title value="แซ่บแบบไหน ถูกใจคุณ🌶️" />
                    <Paragraph value="5 คำถามอาหารเอเชีย… มาดูกันว่าคุณสายไหน" />
                    <Paragraph value="ตอบให้ครบ แล้วรับส่วนลด ฿200 สำหรับ Maxim" />
                  </div>
                  <Button
                    value="เริ่มเลย"
                    onClick={() => startFlow()}
                    id="start"
                  />
                </div>
              </div>
            </>
          ) : stateFlow === "Flow" ? (
            <>
              <div className={styles.posterContainer}>
                <img
                  src={questions[currentQuestion].image}
                  className={styles.image}
                  alt={questions[currentQuestion].image}
                />
              </div>
              <div
                className={classNames({
                  [styles.optionsContainer]: true,
                  [styles.onScrollOption]: offset,
                })}
              >
                <div className={styles.bgWhite}>
                  <div className={styles.header}>
                    <div className={styles.topBarContainer}>
                      <div>ข้อที่ {currentQuestion + 1}</div>
                    </div>
                    <div></div>
                    <Title value={questions[currentQuestion].questionText} />
                  </div>

                  <div className={styles.optionsWrapper}>
                    {questions[currentQuestion].answerOptions.map((item) => (
                      <OptionsItem
                        key={item.answerText}
                        title={item.answerText}
                        resultText={item.answerResult}
                        onClick={optionActiveHandler}
                        disabled={option}
                        result={item.result}
                        resultCountLogic={resultCountLogic}
                      />
                    ))}
                  </div>

                  <Button
                    value="ถัดไป"
                    onClick={() => handlerNext()}
                    disabled={!option}
                    id={"btn" + (currentQuestion + 1)}
                  />
                </div>
              </div>
            </>
          ) : (
            <>{resultState}</>
          )}
        </div>
      </div>
    </div>
  );
}

export default App;
